import { Controller } from '@hotwired/stimulus';

/**
 * @description Syncs values by passing them to a Turbo Stream URL.
 * @param {String} urlValue - The URL to pass the value to. Should contain `__VALUE__` as a placeholder for the value.
 * @example
 * .div data-controller="turbo-sync" data-turbo-sync-url-value="https://example.com/update?value=__VALUE__">
 *   .input data-action="change->turbo-sync#update"
 */
export default class extends Controller {
  static values = {
    url: String
  }

  /**
   * @description Updates the value of the input field.
   * @param {Event} event - The input event containing the value to pass to the URL.
   */
  update(event) {
    const value = event.target.value;
    const url = this.urlValue.replace('__VALUE__', value);

    fetch(url, {
      headers: { Accept: 'text/vnd.turbo-stream.html' }
    })
      .then((response) => response.text())
      .then((html) => Turbo.renderStreamMessage(html));
  }
}
